/*eslint-disable*/
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Button } from "@material-ui/core";
import Lottie from "react-lottie";
import NotNotificationAnimation from "../../../animations/no_notifications_techton.json";

const useStyles = makeStyles((theme) => ({
  gridMain: {
    width: "100%",
    height: "100%",
    margin: "auto",
    // backgroundColor: "red",
  },
}));

export default function NotNotificationsFound(props) {
  const classes = useStyles();

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: NotNotificationAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      className={classes.gridMain}
    >
      <Grid container direction="column" alignItems="center">
        <Lottie options={defaultOptions} height={220} width={238} />
        <Typography
          style={{
            fontFamily: "Roboto",
            fontSize: 26,
            fontWeight: 500,
            color: "#fff",
          }}
        >
          Sin notificaciones
        </Typography>
        <Typography
          style={{
            fontFamily: "Roboto",
            fontSize: 18,
            color: "#acacac",
          }}
        >
          No tienes notificaciones por ver
        </Typography>
      </Grid>
    </Grid>
  );
}
